import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AccessControl from '../../AccessControl';
import Error404 from '../../Error404';
import {
  MODULES_KEY,
  PERMISSION_OBJECT,
  ROUTES,
  ROUTES_MODULES_KEY,
} from '../../common/constants';
import Recordings from './Recordings';
import ViewRecording from './ViewRecording';
import './recordings.less';

function RecordingsWrapper() {
  return (
    <Switch>
      <Route
        exact
        path={`${ROUTES_MODULES_KEY?.RECORDINGS}`}
        render={(props) => (
          <AccessControl
            modulekey={MODULES_KEY?.RECORDINGS}
            allowedPermissions={[PERMISSION_OBJECT?.read]}
            showNoAccess
          >
            <Recordings {...props} />
          </AccessControl>
        )}
      />
      <Route
        exact
        path={`${ROUTES?.VIEW_RECORDING}`}
        render={(props) => (
          <AccessControl
            modulekey={MODULES_KEY?.RECORDINGS}
            allowedPermissions={[PERMISSION_OBJECT?.read]}
            showNoAccess
          >
            <ViewRecording {...props} />
          </AccessControl>
        )}
      />
      <Route path="*" component={Error404} />
    </Switch>
  );
}

export default RecordingsWrapper;
